import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static targets = ["notification"]

  click() {
    const element = this.notificationTarget;
    post(element.dataset.notificationReadingUrl, {
      responseKind: "turbo-stream"
    });
  }
}
